import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import WalletGif from 'enrollment/assets/Wallet.svg';
import {
  DefinedBenefitContributionBannerStyled,
  DefinedBenefitContributionSpacing,
  DefinedBenefitContributionLogoStyled,
} from './DefinedContributionStyled';
import {
  BenefitDto,
  CategoryResponseDto,
  DefinedBenefitCreditDto,
} from 'enrollment/queries/useBenefitCategoryQuery/types';
import { DefinedBenefitContributionDrawer } from './DefinedBenefitContributionDrawer';
import { setTotalDefinedBenefitContribution } from 'enrollment/services/Benefit/slice';

interface DefinedBenefitContributionBannerProps {
  benefits?: CategoryResponseDto;
}

export const DefinedBenefitContributionBanner = ({
  benefits,
}: DefinedBenefitContributionBannerProps) => {
  const { t } = useTranslation('enrollment.benefits');
  const dispatch = useDispatch();

  const formatDollarAmount = (amount: string) => {
    const numericValue = parseFloat(amount);
    return numericValue;
  };

  const summedCreditArray = benefits?.data.benefits?.flatMap(
    (benefit: BenefitDto) => {
      return (
        benefit.coverage?.defined_benefit_credits?.reduce(
          (sum: number, cost: DefinedBenefitCreditDto): number =>
            sum + formatDollarAmount(cost.pay_period_amount),
          0
        ) || 0
      );
    }
  );

  const summedCredit =
    summedCreditArray?.reduce(
      (sum: number, cost: number): number => sum + cost,
      0
    ) || 0;

  // Use effect to handle dispatch outside of render
  useEffect(() => {
    dispatch(setTotalDefinedBenefitContribution(summedCredit));
  }, [dispatch, summedCredit]);

  if (
    benefits &&
    benefits.data.defined_benefit_contributions &&
    benefits.data.defined_benefit_contributions.length > 0 &&
    !benefits.data.defined_benefit_contributions.find(
      (dbc) => dbc.show_in_enrollment === false
    ) &&
    summedCredit > 0
  ) {
    return (
      <aside aria-label={t('ariaNotification')}>
        <DefinedBenefitContributionBannerStyled>
          <DefinedBenefitContributionLogoStyled>
            <img
              src={WalletGif}
              alt=""
              width="100%"
              id="wallet-icon"
              data-testid="wallet-icon"
            />
          </DefinedBenefitContributionLogoStyled>
          <div className="flex-grow-1 mx-3_5">
            <p className="mb-0">
              {t(
                'definedBenefitContribution.definedbenefitContributionBanner1'
              )}
              <span className="mr-1 semiBold">${summedCredit.toFixed(2)}</span>
              {t(
                'definedBenefitContribution.definedbenefitContributionBanner2'
              )}
            </p>
          </div>
          <DefinedBenefitContributionDrawer benefits={benefits} />
        </DefinedBenefitContributionBannerStyled>
        <DefinedBenefitContributionSpacing />
      </aside>
    );
  }
};
